import { render, staticRenderFns } from "./CallsInfo.vue?vue&type=template&id=126201a8"
import script from "./CallsInfo.vue?vue&type=script&lang=js"
export * from "./CallsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports